/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Early_Weak_Pelican_TreasureInputs */

const fr_early_weak_pelican_treasure = /** @type {(inputs: Early_Weak_Pelican_TreasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe oublié`)
};

/**

* @param {Early_Weak_Pelican_TreasureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const early_weak_pelican_treasure = /** @type {((inputs?: Early_Weak_Pelican_TreasureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Early_Weak_Pelican_TreasureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_early_weak_pelican_treasure(inputs)
});